"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bizUserCsvUploadReducer = exports.bizUserCsvUploadActions = exports.TYPES = exports.LOADING_STATUS = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'BizUserCsvUpload';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  // 利用者アップロード画面項目設定
  SET_ENTRY: PREFIX + 'SetEntry',
  // 結果一覧設定
  SET_RESULT_LIST: PREFIX + 'SetResultList',
  // エラー一覧設定
  SET_ERROR_LIST: PREFIX + 'SetErrorList',
  // 画面遷移設定
  SET_DISP_CONTENT: PREFIX + 'SetDispContent',
  // 処理中設定
  SET_LOADING: PREFIX + 'SetLoading',
  // ページングリセット
  RESET_PAGING: PREFIX + 'ResetPaging',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // スクロール位置を変更
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  // 全て表示を変更
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  // アップロード画面へ戻る
  GO_UPLOAD: PREFIX + 'GoUpload',
  // 初期設定
  CLEAR: PREFIX + 'Clear'
};

// 画面遷移用
const CONTENTS = exports.CONTENTS = {
  ENTRY: 'entry',
  RESULT: 'result',
  ERROR: 'error'
};

// 処理中ステータス
const LOADING_STATUS = exports.LOADING_STATUS = {
  NORMAL: 'normal',
  LOADING: 'loading'
};

/**
 * 初期State
 */
const INIT_STATE = {
  dispContent: CONTENTS.ENTRY,
  entries: {
    csvFile: null,
    updateMethod: _CodeConsts.CODE.UPDATE_METHOD.CODE_1
  },
  resultList: [],
  errorList: [],
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  showAll: false,
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  loadingStatus: LOADING_STATUS.NORMAL
};

// アクション定義
const bizUserCsvUploadActions = exports.bizUserCsvUploadActions = (0, _reduxActions.createActions)({
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_RESULT_LIST]: function () {
    return {
      resultList: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ERROR_LIST]: function () {
    return {
      errorList: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_DISP_CONTENT]: function () {
    return {
      dispContent: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_LOADING]: function () {
    return {
      loadingStatus: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.GO_UPLOAD, TYPES.CLEAR);

/**
 * Reducer定義
 */
const bizUserCsvUploadReducer = exports.bizUserCsvUploadReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_RESULT_LIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      resultList: action.payload.resultList
    });
  },
  [TYPES.SET_ERROR_LIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      errorList: action.payload.errorList
    });
  },
  [TYPES.SET_DISP_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.dispContent,
      loadingStatus: LOADING_STATUS.NORMAL
    });
  },
  [TYPES.SET_LOADING]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      loadingStatus: action.payload.loadingStatus
    });
  },
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    const newResultList = JSON.parse(JSON.stringify(state.resultList)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      resultList: newResultList,
      showAll: action.payload.showAll
    });
  },
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: INIT_STATE.paging
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.GO_UPLOAD]: state => {
    return _objectSpread({}, INIT_STATE);
  },
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);